import { InfoOutlined } from '@mui/icons-material';
import { Box, Grid, GridProps, Tooltip, Typography, useTheme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { ReactNode } from 'react';

export type FormInputProps = {
    label: ReactNode | string;
    formComponent: any;
    sx?: SystemStyleObject;
    labelGridItemProps?: GridProps;
    formComponentGridItemProps?: GridProps;
    isRequired?: boolean;
    error?: string;
    disabled?: boolean;
};

export const StandaloneFormInlineInput = ({
    label,
    formComponent,
    sx,
    labelGridItemProps,
    formComponentGridItemProps,
    isRequired,
    error,
    disabled
}: FormInputProps) => {
    const theme = useTheme();
    return (
        <Grid justifyContent="space-between" alignItems="center" sx={{ display: 'flex', width: '100%', ...sx }}>
            <Grid item xs={6} {...labelGridItemProps}>
                <Grid container alignItems="center">
                    <Grid item xs>
                        <Typography fontSize="12px" fontWeight={500} sx={{ color: '#858585' }}>
                            {label}:
                        </Typography>
                    </Grid>
                    <Grid item xs="auto">
                        <Box display="flex" alignItems="center" justifyContent="center" height="100%" sx={{ mr: 2 }}>
                            {isRequired && !disabled && <span style={{ color: theme.palette.error.main, height: '0.875rem' }}>*</span>}
                            {error && !disabled && (
                                <Tooltip title={error} placement="top">
                                    <InfoOutlined sx={{ fontSize: '1rem', color: theme.palette.error.main, ml: '0.25rem' }} />
                                </Tooltip>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={6} {...formComponentGridItemProps}>
                {formComponent}
            </Grid>
        </Grid>
    );
};
